import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { Download } from '@factorialco/f0-react/icons/app'
import {
  FundaeFinishGroupExportDocument,
  FundaeFinishGroupExportMutation,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export function Header({
  selectedClassId,
  onError,
}: {
  selectedClassId?: number
  onError?(): void
}) {
  const { access } = useCurrentSession()
  const [exportTrainingsFundaeFinishGroup] = useMutation(FundaeFinishGroupExportDocument, {
    extractorFn: (data: FundaeFinishGroupExportMutation) =>
      data.trainingsMutations.exportTrainingsFundaeFinishGroup,
  })

  const onSubmit = async () => {
    const result = await exportTrainingsFundaeFinishGroup({
      variables: {
        trainingClassId: Number(selectedClassId),
        authorId: access.id,
      },
    })

    const handled = handleResult(result, (error) => {
      if (error.errors) {
        app.setFlash({
          type: 'wrong',
          message: error.errors,
        })
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.error'),
        })
      }
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.fundae.finish_group_table.export.success'),
      })
    } else if (onError) {
      onError()
    }
  }

  return (
    <SectionHeader
      separator="bottom"
      title={i18n.t('trainings.trainings_detail.fundae.section_header.title')}
      description={i18n.t('trainings.trainings_detail.fundae.section_header.description')}
      link={{
        href: 'https://empresas.fundae.es/Lanzadera',
        label: i18n.t('trainings.trainings_detail.fundae.section_header.support_button.label'),
      }}
      action={{
        icon: Download,
        label: i18n.t('trainings.trainings_detail.fundae.section_header.action.label'),
        onClick() {
          track(trackingEvents.training.trainingDetail.fundae.finishGroupsExport.exportXml)
          onSubmit()
        },
      }}
    />
  )
}
